/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HighRiskServiceRaiseResponse
 */
export interface HighRiskServiceRaiseResponse {
    /**
     * 
     * @type {string}
     * @memberof HighRiskServiceRaiseResponse
     */
    highRiskId?: string | null;
}

/**
 * Check if a given object implements the HighRiskServiceRaiseResponse interface.
 */
export function instanceOfHighRiskServiceRaiseResponse(value: object): value is HighRiskServiceRaiseResponse {
    return true;
}

export function HighRiskServiceRaiseResponseFromJSON(json: any): HighRiskServiceRaiseResponse {
    return HighRiskServiceRaiseResponseFromJSONTyped(json, false);
}

export function HighRiskServiceRaiseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HighRiskServiceRaiseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'highRiskId': json['highRiskId'] == null ? undefined : json['highRiskId'],
    };
}

export function HighRiskServiceRaiseResponseToJSON(json: any): HighRiskServiceRaiseResponse {
    return HighRiskServiceRaiseResponseToJSONTyped(json, false);
}

export function HighRiskServiceRaiseResponseToJSONTyped(value?: HighRiskServiceRaiseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'highRiskId': value['highRiskId'],
    };
}

